<!--
  Internally used by <comparator> to display each item
-->

<template>
  <el-collapse-transition>
    <div v-show="!hidden" class="comparator-vue" :class="{
      'comparator-vue-view': !compare,
      'comparator-vue-compare': compare,
      'comparator-vue-other': other !== undefined,
      'comparator-vue-hidden': hidden,
    }">
      <slot
        :value="value" :other="other"
        :index="index"
        :view="!compare || undefined"
        :compare="compare || undefined"
        :listeners="computedListeners"
        :attrs="computedAttrs"
        :vuedata="vuedata">
      </slot>
    </div>
  </el-collapse-transition>
</template>

<script>
export default {
  name: 'ComparatorVue',
  props: {
    value: {},
    other: {},
    index: Number,
    vuekey: String,
    compare: Boolean,
    hidden: Boolean,
    listeners: Object,
    attrs: Object,
    vuedata: Object,
  },
  data () {
    return {
      // the comparable object, built from all <comparable>
      comparable: {},
    }
  },
  computed: {
    /* only show the listeners if from view */
    computedListeners () {
      return this.compare ? {} : this.listeners || {}
    },
    /* only show the attrrs if from view */
    computedAttrs () {
      return this.compare ? {} : this.attrs || {}
    },
  },
  provide () {
    return {
      // for <comparable> to push their updates
      comparator: this,
    }
  },
  methods: {
    /* called by <comparable> to update theur comparable value */
    setComparable (name, value) {
      // undefined means a deletion
      if (value === undefined) this.$delete(this.comparable, name)
      // update the comaprable field
      else this.$set(this.comparable, name, value)
      // emit for <comparator> to udpate
      this.$emit('comparable', this.comparable)
    },
  },
}
</script>
